// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xd1o","controls":"styles_controls__3v_Cr","charLimit":"styles_charLimit__xF4bA","input":"styles_input__BGv6l","send":"styles_send__c4VrM"};